module.exports = __webpack_public_path__ + "static/media/dot_icon.64c4b3fa.svg";